/** 绩效匹配展示只认 snapshot */

const ROLE_LABELS = {
	assistant: '销售助理',
	sale: '销售员',
	salesSupervisor: '销售主管',
};

const formatBasisScopeLabel = (rule, roleKey) => {
	if (roleKey === 'assistant' && (rule?.matchReason === 'order_level' || ((rule?.brand || '全部') === '全部' && (rule?.category || '全部') === '全部'))) {
		return '整单';
	}
	if (roleKey === 'salesSupervisor' && rule?.matchReason === 'no_supervisor') {
		return '无销售主管';
	}
	return `${rule?.brand || '全部'} / ${rule?.category || '全部'}`;
};

const getRoleBasisIssue = (rules, roleKey) => {
	const roleLabel = ROLE_LABELS[roleKey] ?? roleKey;
	if (!Array.isArray(rules) || rules.length === 0) {
		return { role: roleKey, roleLabel, problem: 'missing', scopes: [] };
	}
	const unmatched = rules.filter((rule) => rule?.matchReason === 'no_match');
	if (unmatched.length === 0) return null;
	return {
		role: roleKey,
		roleLabel,
		problem: 'no_match',
		scopes: unmatched.map((rule) => formatBasisScopeLabel(rule, roleKey)),
	};
};

export const getOrderPerformanceBasisView = (order) => {
	const snapshot = order?.performanceRulesSnapshot ?? {};
	const assistantRules = snapshot.assistantRules ?? [];
	const saleRules = snapshot.saleRules ?? [];
	const salesSupervisorRules = snapshot.salesSupervisorRules ?? [];
	const snapshotRuleCount = assistantRules.length + saleRules.length + salesSupervisorRules.length;

	if (snapshotRuleCount === 0) {
		return { snapshotRuleCount: 0, hasBasis: false, hasUnmatched: false, unmatchedIssues: [] };
	}

	const issues = [];
	const assistantIssue = getRoleBasisIssue(assistantRules, 'assistant');
	const saleIssue = getRoleBasisIssue(saleRules, 'sale');
	if (assistantIssue) issues.push(assistantIssue);
	if (saleIssue) issues.push(saleIssue);
	const requiresSupervisor = salesSupervisorRules.some((rule) => rule?.matchReason !== 'no_supervisor');
	if (requiresSupervisor) {
		const supervisorIssue = getRoleBasisIssue(
			salesSupervisorRules.filter((rule) => rule?.matchReason !== 'no_supervisor'),
			'salesSupervisor',
		);
		if (supervisorIssue) issues.push(supervisorIssue);
	}

	return {
		snapshotRuleCount,
		hasBasis: true,
		hasUnmatched: issues.length > 0,
		unmatchedIssues: issues,
	};
};
